import { LargeOptionCard } from "./LargeOptionCard";

type Option = {
  value: string;
  label: string;
  icon: React.ReactNode;
};

type LargeCardStepProps = {
  title: string;
  description?: string;
  options: Option[];
  value?: string;
  onChange: (value: string) => void;
};

export function LargeCardStep({
  title,
  description,
  options,
  value,
  onChange,
}: LargeCardStepProps) {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-xl font-bold text-[var(--text-primary)]">{title}</h2>
        {description && <p className="text-sm text-[var(--text-muted)]">{description}</p>}
      </header>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {options.map((opt) => (
          <LargeOptionCard
            key={opt.value}
            icon={opt.icon}
            title={opt.label}
            selected={value === opt.value}
            onSelect={() => onChange(opt.value)}
          />
        ))}
      </div>
    </div>
  );
}
